import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
import { Highlight } from "react-instantsearch";
import { companyUrl } from "views_shared/app/javascript/utils/urls";
import Hashtags from "../../hashtags";
import OverviewQuoteOrExpertList from "./overview_quote_or_expert_list";

function CompanyCard({ slug, name, profileImageUrl = undefined, id, migrateId = undefined, searchHit }) {
  const companyPath = companyUrl({ slug, migrate_id: migrateId });

  return (
    <div className="card company-card h-100 animated faster fadeIn" aria-hidden="true">
      <div className="card-body position-relative">
        <div className="d-flex">
          {profileImageUrl && (
            <div className="flex-shrink-0">
              <Image fluid src={profileImageUrl} alt={name} width={64} height={64} />
            </div>
          )}

          <div className="flex-grow-1 ms-3">
            <div>
              <h6 className="mb-2 fw-bold">
                <a href={companyPath}>
                  {searchHit && <Highlight attribute="name" hit={searchHit} />}
                  {!searchHit && name}
                </a>
              </h6>
            </div>
            <Hashtags
              taggedId={id}
              taggedType="Id::PromoEntity"
              maxHashtags={4}
              clickEventName="Companies/CompanyCard#clickHashtag"
            />
          </div>
        </div>

        {searchHit && (
          <div className="row">
            <div className="col">
              <OverviewQuoteOrExpertList searchHit={searchHit} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

CompanyCard.propTypes = {
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  profileImageUrl: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  migrateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CompanyCard;
